import { useBriefContext } from '../../../BriefContext';
import { useResolveServiceProductMpvId } from '../../hooks/useResolveServiceProductMpvId';
import { useSelectProductWithCacheUpdate } from '../ClientConfiguredFields/ProductDropdown/useSelectProductMutation';
import { useUpdateField } from '../useUpdateField';
import { useBriefSetGridChoiceMutation } from './briefSetGridChoice.generated';

export function useUpdateGridChoiceField(
    key: string,
    briefId?: string,
    initialValue?: string | null
) {
    const { selectProduct } = useSelectProductWithCacheUpdate();
    const { serviceProductMpvId, expertService } = useBriefContext();
    const printProductMpvId = expertService?.printProduct?.mpvId;
    const resolveServiceProductMpvId = useResolveServiceProductMpvId();

    const [setGridChoice] = useBriefSetGridChoiceMutation({
        onCompleted: async (briefData) => {
            if (key !== 'requestType') {
                return;
            }
            const field = briefData.setField.dynamicFields.find((field) => field.id === key);
            if (!field) {
                return;
            }
            if (field.__typename !== 'GridChoiceField') {
                throw new Error(
                    "Field is not a GridChoiceField. This schema is not compatible with the fields currently in use on the front end. And will cause all kinds of trouble. If you're seeing this error in bugsnag, investigate immediately"
                );
            }
            if (briefData.setField.correlationId && serviceProductMpvId) {
                const resolvedMpvId = await resolveServiceProductMpvId({
                    printProductMpvId,
                });

                selectProduct({
                    variables: {
                        requestId: briefData.setField.correlationId,
                        input: {
                            serviceProductMpvId: resolvedMpvId,
                            printProductMpvId: [],
                        },
                    },
                });
            }
        },
    });
    return useUpdateField<string>({ key, setField: setGridChoice, briefId, initialValue });
}
